module.exports = __webpack_public_path__ + "img/picto-plus.96d679a7.svg";